var map = {
	"./basic_info.svg": "fd73",
	"./change_login_pwd.svg": "1203",
	"./chevron-right.svg": "50ff",
	"./invite_link.svg": "efaa",
	"./kyc.svg": "807e",
	"./languageSetting.svg": "0ad2",
	"./plus.svg": "2704",
	"./register.svg": "2627",
	"./reset_sec_password.svg": "f563"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "753e";